<template>
  <div>
    <router-view v-is-mobile v-is-tablet />
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true
    };
  },
  mounted() {
    this.loading = false;
    this.$store.commit("changeLang", "es");
  },
};
</script>


<style lang="scss">
.v-data-footer {
  justify-content: flex-start !important;
  width: 100%;
}
.v-data-footer__pagination {
  margin-left: auto !important;
}
.v-data-footer__icons-before,
.v-data-footer__icons-after {
  margin-left: 0 !important;
}
.v-data-footer__select::after {
  content: 'por página';
  white-space: nowrap;
  align-self: center;
  margin-left: 8px;
}
.v-data-footer__select .v-select__selections {
  justify-content: center !important;
}

// Convencion de UI del proyecto: todo control tipo select muestra cursor de mano
// cuando esta habilitado. Vuetify marca los deshabilitados con la clase
// v-input--is-disabled. v-autocomplete extiende v-select y por eso lleva tambien
// la clase v-select, asi que queda cubierto por la misma regla.
select:not(:disabled) {
  cursor: pointer;
}

// El editor de texto enriquecido (vue2-editor) va dentro de v-card-text, y
// Vuetify pinta ese contenedor en rgba(0,0,0,.6). Quill no fija color propio y
// lo hereda, asi que lo que se escribe se ve gris cuando el correo lo va a
// mostrar en negro. Se fija el color por defecto del correo; un color elegido
// desde la barra del editor sigue viajando inline y gana igual.
.quillWrapper .ql-editor {
  color: #000;
}

.v-select:not(.v-input--is-disabled) {
  .v-input__slot,
  .v-select__selections,
  input,
  // La flecha del desplegable: Vuetify le pone cursor propio al icono.
  .v-input__append-inner,
  .v-input__append-inner .v-icon {
    cursor: pointer;
  }
}
</style>

<style scoped lang="scss">
html {
  overflow-y: auto;
}

.app-bar-loader ::v-deep .loading-bar {
  width: 6px;
  animation: custom-loading-wave-animation 1s ease-in-out infinite;
}

.app-bar-loader ::v-deep .loading-bar:nth-child(2) {
  animation-delay: 0.1s;
}

.app-bar-loader ::v-deep .loading-bar:nth-child(3) {
  animation-delay: 0.2s;
}

.app-bar-loader ::v-deep .loading-bar:nth-child(4) {
  animation-delay: 0.3s;
}

@keyframes custom-loading-wave-animation {
  0% {
    height: 6px;
  }

  50% {
    height: 60px;
  }

  100% {
    height: 6px;
  }
}

.theme--light .v-toolbar,
.application .theme--light.v-toolbar {
  background-color: #fff;
}

.fixed-header th {
  position: sticky;
  top: 0px;
  background-color: white;
  z-index: 4;
}
.fixed-header .v-table__overflow {
  overflow: unset;
}

.capitalize {
  text-transform: capitalize;
}
</style>
